import styled from 'styled-components';

export const TooltipContainer = styled.div`
    position: relative;
    display: inline-flex;
`;

export const TooltipContent = styled.div<{
    position: 'top' | 'bottom' | 'left' | 'right';
    isVisible: boolean;
    maxWidth: string;
    minWidth: string;
}>`
    position: absolute;
    background-color: ${props => props.theme.colors.backgroundDark};
    color: ${props => props.theme.colors.textLight};
    padding: 0;
    border-radius: 4px;
    font-size: 12px;
    line-height: 1.4;
    z-index: 1000;
    opacity: ${props => (props.isVisible ? 1 : 0)};
    visibility: ${props => (props.isVisible ? 'visible' : 'hidden')};
    transition: opacity 0.2s ease, visibility 0.2s ease;
    max-width: ${props => props.maxWidth};
    min-width: ${props => props.minWidth};
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
    pointer-events: none;
    overflow: hidden;
    
    /* Position calculations */
    ${props => props.position === 'top' && `
        bottom: 100%;
        left: 50%;
        transform: translateX(-50%);
        margin-bottom: 8px;
    `}
    
    ${props => props.position === 'bottom' && `
        top: 100%;
        left: 50%;
        transform: translateX(-50%);
        margin-top: 8px;
    `}
    
    ${props => props.position === 'left' && `
        right: 100%;
        top: 50%;
        transform: translateY(-50%);
        margin-right: 8px;
    `}
    
    ${props => props.position === 'right' && `
        left: 100%;
        top: 50%;
        transform: translateY(-50%);
        margin-left: 8px;
    `}
    
    &:after {
        content: '';
        position: absolute;
        border-style: solid;
        border-width: 4px;
        
        ${props => props.position === 'top' && `
            top: 100%;
            left: 50%;
            transform: translateX(-50%);
            border-color: ${props.theme.colors.backgroundDark} transparent transparent transparent;
        `}
        
        ${props => props.position === 'bottom' && `
            bottom: 100%;
            left: 50%;
            transform: translateX(-50%);
            border-color: transparent transparent ${props.theme.colors.backgroundDark} transparent;
        `}
        
        ${props => props.position === 'left' && `
            left: 100%;
            top: 50%;
            transform: translateY(-50%);
            border-color: transparent transparent transparent ${props.theme.colors.backgroundDark};
        `}
        
        ${props => props.position === 'right' && `
            right: 100%;
            top: 50%;
            transform: translateY(-50%);
            border-color: transparent ${props.theme.colors.backgroundDark} transparent transparent;
        `}
    }
`;

export const TooltipHeader = styled.div`
    background-color: rgb(0, 68, 126);
    color: white;
    padding: 6px 12px;
    font-weight: 600;
    font-size: 13px;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
`;

export const TooltipBody = styled.div`
    padding: 8px 12px;
    white-space: normal;
    word-break: break-word;
    background: #fff;
`;